import { useParams } from "react-router-dom";

import { BaseModal } from "../../../common-ui/modal/BaseModal";
import { useAppNavigate } from "../../../common/hooks/useAppNavigate";
import { usePageTitle } from "../../../common/routes/PageTitle";
import { IntermodalBookingUpdateModalContainer } from "./IntermodalBookingUpdateModalContainer";

export const IntermodalBookingUpdateModal = () => {
  const { bookingNo: bookingNoString } = useParams<"bookingNo">();
  const { pop } = useAppNavigate();
  usePageTitle(`Intermodal booking ${bookingNoString}`);

  return (
    <BaseModal className={"t_intermodal_edit_modal"} onRequestClose={pop}>
      <IntermodalBookingUpdateModalContainer
        bookingNo={Number(bookingNoString)}
        onRequestClose={pop}
      />
    </BaseModal>
  );
};
